// Action Types
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_BREADCRUMB = 'SET_BREADCRUMB';

// Action Creator
export const setLanguage = (payload) => ({ type: SET_LANGUAGE, payload });
export const setBreadcrumb = (payload) => ({ type: SET_BREADCRUMB, payload });

